
export class RequestItemContainerModel {
   NumberOfContainer: number;
   AmountPerContainer: number;
   ContainerLabel: string;
   SerialNumber: number;
   RequestItemContainerId: number;
   IsContainerDeleted: boolean;
}